import { Fragment } from 'react';

import { CheckoutField } from '@mews-distributor/common';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews/text-keys';
import { Stack } from '@optimus-web/core';

import { PaymentCardExpiration, PaymentCardHolderName } from './components';

export const PaymentCardFormSection =
    ({ renderPaymentCardNumber, renderPaymentCvv }: $TSFixMe) =>
    () => (
        <Stack spacing="200" vertical>
            <Stack
                spacing="200"
                distribution="stretch"
                largePhoneMax={{
                    vertical: true,
                }}
            >
                {renderPaymentCardNumber()}
                <Stack spacing="200" distribution="stretch">
                    <PaymentCardExpiration
                        // @ts-expect-error $TSFixMeError: Type '{ name: CheckoutField; label: Element; autoComplete: string; }' is not assignable to type 'IntrinsicAttributes & O...
                        name={CheckoutField.CardExpiration}
                        label={
                            <Fragment>
                                <LocalizedText textKey={TextKey.PaymentCardExpiration} />
                                {' (MM/YY)'}
                            </Fragment>
                        }
                        autoComplete="cc-exp"
                    />
                    {renderPaymentCvv()}
                </Stack>
            </Stack>
            <Stack
                spacing="200"
                distribution="stretch"
                largePhoneMax={{
                    vertical: true,
                }}
            >
                <PaymentCardHolderName
                    // @ts-expect-error $TSFixMeError: Type '{ name: CheckoutField; label: Element; }' is not assignable to type 'IntrinsicAttributes & Omit<any, string | numb...
                    name={CheckoutField.CardHolderName}
                    label={<LocalizedText textKey={TextKey.NameOnCard} />}
                />
                <div />
            </Stack>
        </Stack>
    );
